<template>
  <div id="raft-add-new-bio-mat">
    <b-link @click="addMaterialStub" href="#">
      Create a new {{ materialTypeLabel }}
    </b-link>
  </div>
</template>

<script>
import { restClient } from "../../lib/raftApi";
import raftGenericHelper from "../../lib/raft_generic_helper";

export default {
  name: "AddNewBioMaterial",
  props: {
    materialType: {
      type: String,
      required: true,
    },
    materialTypeLabel: {
      type: String,
      required: true,
    },
  },
  methods: {
    addMaterialStub: async function () {
      const path = `/bio-material/library/${this.materialType}`;
      const responseData = await restClient
        .post({ path, queries: {}, data: {} })
        .catch((e) => {
          this.$emit("add-material-error-message", {
            message: e.message,
            data: e.data,
          });
        });
      if (responseData?.uuid) {
        const url = `/raft/biologicals/${this.materialType}/${
          responseData?.uuid?.[0]?.value
        }/edit?${raftGenericHelper.getDestinationQuery()}`;
        window.location.href = url;
      }
    },
  },
};
</script>

<style scoped>
div {
  text-align: right;
}
#raft-add-new-bio-mat {
  float: right;
}
</style>
